import React from 'react';

import Wrapper from './styles';

const Index = () => {
  return <Wrapper />;
};

export default Index;
